//LIBRARIES
import React from 'react';
import styled from 'styled-components';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

//HELPERS
import { getTranslatedString } from 'helpers/i18n';
import { formatMoney } from 'helpers/Formatter';

const Divider = styled.hr`
  border-top: 1px solid #bbb;
  margin-top: 0;
`;

const StyledAmount = styled.div`
  text-align: center;
  line-height: 22px;
`;

const StyledTextCenter = styled.div`
  text-align: center;
  margin-bottom: 10px;
`;

const StyledTextRight = styled.p`
  text-align: right;
  font-size: 18px;
  font-weight: 600;
`;

const StyledTextLeft = styled.p`
  text-align: left;
  font-size: 14px;
`;

const StyledFooter = styled.p`
  text-align: center;
`;

const StyledAutoPayConfirmation = styled.div`
  text-align: center;
  width: 80%;
  margin: auto;
`;

const StyledTotalMonthlyBalance = styled.p`
  font-size: 18px;
  line-height: 20px;
  font-weight: 600;
  margin-right: 10px;
`;

const StyledOutlineIcon = styled(InfoOutlinedIcon)`
  font-size: 16px;
  vertical-align: text-bottom;
  margin-right: 5px;
`;

const AutoPayConfirmation = ({
  description,
  showProcessFeeTip,
  footer,
  type,
  specificAmount,
  processFee,
}) => {
  let content =
    type === 'partial' ? (
      <SpecificAmountContent specificAmount={specificAmount} processFee={processFee} />
    ) : (
      <FullAmountContent processFee={processFee} />
    );

  return (
    <StyledAutoPayConfirmation>
      <div>
        <p style={{ marginBottom: '20px' }}>{description}</p>
      </div>
      {content}
      {showProcessFeeTip && parseFloat(processFee) > 0 && <ProcessFeeTip />}
      <StyledFooter>{footer}</StyledFooter>
    </StyledAutoPayConfirmation>
  );
};

const ProcessFeeTip = () => (
  <StyledTextCenter>
    <StyledOutlineIcon />
    {getTranslatedString('autopay.processingFeeByYuhu')}
  </StyledTextCenter>
);

const FullAmountContent = ({ processFee }) => (
  <StyledTextCenter>
    <p>{getTranslatedString('autopay.paymentAmount')}</p>
    <StyledTotalMonthlyBalance>
      {getTranslatedString('autopay.totalMonthlyBalance')}
    </StyledTotalMonthlyBalance>
    {
        parseFloat(processFee) > 0 &&
        <p style={{ display: 'inline-flex' }}>
            <StyledTotalMonthlyBalance>{`+ ${formatMoney(processFee)}`}</StyledTotalMonthlyBalance>
            {`(${getTranslatedString('autopay.processingFees')})`}
        </p> 
    }
  </StyledTextCenter>
);

const SpecificAmountContent = ({ specificAmount, processFee }) => (
  <StyledAmount>
    <div className="row">
      <div className="col-sm-6" style={{ padding: 0 }}>
        <StyledTextLeft>{getTranslatedString('autopay.specificAmount')}</StyledTextLeft>
      </div>
      <div className="col-sm-6" style={{ padding: 0 }}>
        <StyledTextRight>{formatMoney(specificAmount)}</StyledTextRight>
      </div>
    </div>
    {
        parseFloat(processFee) > 0 &&
        <div className="row">
            <div className="col-sm-6" style={{ padding: 0 }}>
                <StyledTextLeft>{getTranslatedString('autopay.processingFees')}</StyledTextLeft>
            </div>
            <div className="col-sm-6" style={{ padding: 0 }}>
                <StyledTextRight>{formatMoney(processFee)}</StyledTextRight>
            </div>
        </div>
    }
    <Divider />

    <div className="row">
      <div className="col-sm-6" style={{ padding: 0 }}>
        <StyledTextLeft>{getTranslatedString('autopay.totalMonthlyPayment')}</StyledTextLeft>
      </div>
      <div className="col-sm-6" style={{ padding: 0 }}>
        <StyledTextRight>{formatMoney(specificAmount + processFee)}</StyledTextRight>
      </div>
    </div>
  </StyledAmount>
);

export default AutoPayConfirmation;
